import { History } from "history";
import { combineReducers } from "redux";
import { StateType } from "typesafe-actions";
import { connectRouter } from "connected-react-router";

// related reducers
import { userRoleReducer } from "../reducers/userRole/userRole.reducers";
import { modalReducer } from "../reducers/modal/modal.reducers";
import { UserReducer } from "../reducers/user/user.reducers";
import { BentukKerjasamaReducer } from "../reducers/bentukKerjasama/bentukKerjasama.reducers";
import { StatusKerjasamaReducer } from "../reducers/statusKerjasama/statusKerjasama.reducers";
import { JenisLembagaReducer } from "../reducers/jenisLembaga/jenisLembaga.reducers";
import { JenisDokumenReducer } from "../reducers/jenisDokumen/jenisDokumen.reducers";
import { PartnerReducer } from "../reducers/partner/partner.reducers";
import { NegaraReducer } from "../reducers/negara/negara.reducers";
import { EmployeeReducer } from "../reducers/employee/employee.reducers";
import { DokumenKerjasamaReducer } from "../reducers/dokumenKerjasama/dokumenKerjasama.reducers";
import { MonevReducer } from "../reducers/monev/monev.reducers";
import { DepartmentReducer } from "../reducers/department/department.reducers";
import { AuthorizationReducer } from "../reducers/authorization/authorization.reducers";

export const makeRootReducer = (history: History) => {
  return combineReducers({
    // core
    monev: MonevReducer,
    dokumenKerjasama: DokumenKerjasamaReducer,

    // partner
    partner: PartnerReducer,
    
    // master data
    jenisLembaga: JenisLembagaReducer,
    jenisDokumen: JenisDokumenReducer,
    bentukKerjasama: BentukKerjasamaReducer,
    statusKerjasama: StatusKerjasamaReducer,

    // user settings
    user: UserReducer,
    userRole: userRoleReducer,

    // general
    modal: modalReducer,
    router: connectRouter(history),
    authorization: AuthorizationReducer,

    // umn related view
    negara: NegaraReducer,
    employee: EmployeeReducer,
    department: DepartmentReducer,
  });
};

export type RootState = StateType<ReturnType<typeof makeRootReducer>>;
